import { reducer as reduxFormReducer } from 'redux-form';

import { LOAD_CONTEXT, LOAD_DATABASE, SHOW_ERROR, SHOW_SPINNER, TOGGLE_MESSAGE, UPDATE_LANG, UPDATE_VARIABLES } from './action';

export function reducer(state=null, action) {
  switch (action.type) {
  case TOGGLE_MESSAGE:
    const { message, level } = action;
    return {
      ...state,
      message: {content: message, level},
    };
  case LOAD_CONTEXT:
    const { mode, user, urls } = action;
    return {
      ...state,
      mode,
      user,
      urls,
    };
  case LOAD_DATABASE:
    const database = action.database;
    const databaseLabel = action.databaseLabel;
    const models = action.models
      .map(({model_id, model_name, model_shortname, calendar}) => ({id: model_shortname, name: `${model_name}/${model_shortname} (${calendar})`}));
    const ensembles = action.ensembles
      .map(({ensemble_id, ensemble_name, ensemble_shortname}) => ({id: ensemble_shortname, name: ensemble_name}));
    const experiments = action.experiments
      .map(({experiment_id, experiment_name, experiment_shortname}) => ({id: experiment_shortname, name: experiment_name}));
    const frequencies = action.frequencies
      .map(({frequency_id, frequency_name, frequency_shortname}) => ({id: frequency_shortname, name: frequency_name}));
    const variables = action.variables
      .map(({variable_id, variable_name, variable_longname, realm, unit, grads_unit}) => ({id: variable_name, name: `${variable_name} (${variable_longname})`, unit}));
    const config = action.config;
    return {
      ...state,
      database,
      databaseLabel,
      models,
      ensembles,
      experiments,
      frequencies,
      variables,
      config,
    };
  case SHOW_ERROR:
    console.error(action.message);
    return state;
  case SHOW_SPINNER:
    const loading = action.enable;
    return {
      ...state,
      loading,
    };
  case UPDATE_LANG:
    const { lang } = action;
    return {
      ...state,
      lang,
    };
  case UPDATE_VARIABLES:
    const availableVariables = action.variables.map(e => e.variable_name);
    return {
      ...state,
      availableVariables,
    };
  default:
    return null;
  }
}
